<template>
  <v-progress-circular
    :width="2"
    :size="20"
    indeterminate
    color="primary"
  ></v-progress-circular>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.extend({
  name: "ActionsLoader",
  data() {
    return {};
  },
  props: {
    action: VueTypes.any.def({}),
  },
});
</script>
